import { Modal, ModalBody, ModalFooter, ROLE, SIZE } from 'baseui/modal';
import { CheckCircleSVG, CloseCircle } from 'common/assets';
import Separator from 'components/common/separator';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import { DialogCommonStyles } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
}

export default function OpenTicketCancelDialog(props: Props) {
  const { onCancel, onConfirm } = props;
  const { t } = useTranslation();

  return (
    <Modal
      closeable={false}
      isOpen
      animate
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      size={SIZE.default}
      role={ROLE.dialog}
      overrides={DialogCommonStyles}
    >
      <ModalBody
        $style={{
          textAlign: 'center',
        }}
      >
        <Separator gap={24} />
        <Text variant="HeadingSmall">
          {t('ticketSales:cancel_open_ticket')}
        </Text>
        <Separator gap={16} />
        <Text variant="ParagraphMedium">
          {t('ticketSales:confirmation_cancel_open_ticket')}
        </Text>
        <Separator gap={16} />
        <Text variant="ParagraphMedium" color="#D44333">
          {t('common:all_changes_will_be_lost')}
        </Text>
      </ModalBody>
      <ModalFooter $style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          buttonType="tertiary"
          isError
          onClick={onCancel}
          startEnhancer={(color, size) => (
            <CloseCircle width={size} height={size} color={color} />
          )}
        >
          {t('common:cancel')}
        </Button>
        <Separator gap={8} />
        <Button
          buttonType="primary"
          onClick={onConfirm}
          startEnhancer={(color, size) => (
            <CheckCircleSVG width={size} height={size} color={color} />
          )}
        >
          {t('common:confirmation')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
